import { ToneMapping } from './rendererTypes';

/**
 * Scene viewer config.
 */
export type SceneViewerConfig = {
  fabricMipmapsHighQuality: boolean;
  frustumCulling: boolean;
  garmentGeometryResource: boolean;
  hideStitches: boolean;
  toneMapping: ToneMapping;
  toneMappingExposure: number;
  useOrderIndependentTransparency: boolean;
  useStitchesDecals: boolean;
};

/**
 * Create scene viewer config.
 * @param config - Configuration options.
 */
export const create = (() => {
  const ConfigDef: SceneViewerConfig = {
    fabricMipmapsHighQuality: true,
    frustumCulling: true,
    garmentGeometryResource: true,
    hideStitches: false,
    toneMapping: ToneMapping.NEUTRAL,
    toneMappingExposure: 1,
    useOrderIndependentTransparency: false,
    useStitchesDecals: true,
  };

  return (config?: Partial<SceneViewerConfig>) => {
    config ??= {};
    const all = { ...ConfigDef, ...config };
    return all;
  };
})();
